<template>
      <div class="appointmentTypeCreate">
        <v-breadcrumbs>
          <v-breadcrumbs-item :exact="true" :to="{ name: 'home', params: {} }"
            >Home</v-breadcrumbs-item
          >
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item :exact="true" :to="{ name: 'appointmentType', params: {} }">
          Appointment Type
          </v-breadcrumbs-item>
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item :to="{ name: 'appointmentTypeCreate', params: {} }">
            Create Appointment Type
          </v-breadcrumbs-item>
        </v-breadcrumbs>

        <v-card>
          <v-card-title>Create Appointment Type</v-card-title>
          <v-card-text>
            <appointmentType-form></appointmentType-form>
          </v-card-text>
        </v-card>
      </div>
    </template>
    <script>
    import AppointmentTypeForm from './AppointmentTypeForm.vue';

    export default {
      name: 'appointmentType',
      components: {
        AppointmentTypeForm
      },
      created() {
        this.$emit("showParent", false);
      }
    }
    </script>
    